import React, { useState } from "react";
import { Box, Typography, Button, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import BannerImage from "../Images/Banner1.png"; // Adjust path
import RequestDemoModal from "./RequestDemoModal"; // Import the modal

const Banner = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <Box
        display="flex"
        flexDirection={isMobile ? "column" : "row"}
        alignItems="center"
        justifyContent="space-between"
        px={4}
        py={6}
        bgcolor="#fff"
      >
        {/* Left Text Content */}
        <Box flex={1} pr={isMobile ? 0 : 4}>
          <Typography
            variant="h5"
            fontWeight="bold"
            gutterBottom
            sx={{ fontSize: "2.5rem" }}
          >
            <span style={{ color: "#2e89ff" }}>
              “Changing talent acquisition ecosystem
            </span>{" "}
            would impact the future of college – Join the movement to get placed
            with{" "}
            <span style={{ color: "#2e89ff" }}>
              Companies looking to assess human Centric Skillset
            </span>{" "}
            and Mindset”
          </Typography>

          <Typography mt={3} color="text.secondary" sx={{ fontSize: "1rem" }}>
            Our human centric skillset focused Interview assessment helps
            students navigate their preparation better and get college the
            access to better placements, better companies and thereby better
            admission
          </Typography>

          <Button
            variant="contained"
            onClick={() => setOpenModal(true)}
            sx={{
              mt: 4,
              backgroundColor: "#2e89ff",
              color: "#fff",
              px: 4,
              py: 1,
              textTransform: "none",
              borderRadius: 2,
              "&:hover": {
                backgroundColor: "#1e69d4",
              },
            }}
          >
            Request A Demo
          </Button>
        </Box>

        {/* Right Image */}
        <Box
          flex={1}
          mt={isMobile ? 4 : 0}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Box
            component="img"
            src={BannerImage}
            alt="Human centric skillset"
            sx={{
              maxWidth: "100%",
              height: "auto",
              borderRadius: 2,
            }}
          />
        </Box>
      </Box>

      {/* Demo Form Modal */}
      <RequestDemoModal open={openModal} onClose={() => setOpenModal(false)} />
    </>
  );
};

export default Banner;
